import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Unity, { UnityContext } from "react-unity-webgl"
var buildUrl = "CheckersBuild";
var loaderUrl = buildUrl + "/CheckerBuild.loader.js";

const Checkers = () => {
    const [name, setName] = useState('')
    const [progress, setProgress] = useState(0)
    const [loaded, setLoaded] = useState(false)
    const [result, setResult] = useState([]);
    const unityContext = new UnityContext({
        loaderUrl: loaderUrl,
        dataUrl: buildUrl + "/CheckerBuild.data",
        frameworkUrl: buildUrl + "/CheckerBuild.framework.js",
        codeUrl: buildUrl + "/CheckerBuild.wasm",
    });

    useEffect(() => {
        unityContext.on("progress", function (progression) {
            setProgress(progression);
        });

        unityContext.on("loaded", function () {
            setLoaded(true);
        });
    }, [])


    useEffect(() => {

        const id = String(Math.random())
        console.error('IM ' + id);
        unityContext.on('Request_WalletAddress', (receiverObject) => {
            unityContext.send(receiverObject, 'Received_WalletAddress', id);
        })
        unityContext.on('Match_Joined', (matchID, playerWalletAddress) => {
            console.log(playerWalletAddress);
            console.warn('JOINED game ' + matchID + ' with player ' + playerWalletAddress)
        })

        unityContext.on('Match_End', (matchID, winnerWalletAddress) => {
            console.error('END game ' + matchID + ' with winner ' + winnerWalletAddress)
        })


    })

   

    useEffect(() => {
        axios.get("Connect the result Api")
            .then(res => {
                setResult(res.data)
            })
            .catch(err => {
                console.log(err)
            })
    }, [])

    return (
        <>
            <div className="checker-root" style={{ display: 'flex', flex: 1, placeItems: 'center', width: '100%', justifyItems: 'center' }}>
                <div style={{ marginInline: 'auto', position: 'relative' }}>
                    <div id="unity-build-title">Checkers</div>
                    <Unity unityContext={unityContext} />
                    {/* {!loaded && <div style={{ aspectRatio: '9/16', minHeight: '85vh', position: 'absolute', backgroundColor: 'black', top: 0, display: 'grid', placeItems: 'center' }}>

                        <div className="" style={{ height: 16, width: '50%', backgroundColor: '#222', position: 'relative' }}>
                            <div style={{ position: 'absolute', left: 0, top: 0, height: 16, width: `${progress * 100}%`, backgroundColor: 'white' }}></div>
                        </div>

                    </div>} */}
                </div>
            </div>

            { 
                    result.map(result =>{
                    return (
                        <>
                        </>
                    )
                })
            }
            {/* <div className='container-fluid text-light'>
                <div className='row mt-4'>
                    <div className='col-lg-6 col-md-6'>
                        <div className='player2 mt-3'>
                            <h2 className=' player text-center'>Player-1</h2>
                            <h2 className=' '>Player Address:-{result.title}</h2>
                        </div>

                    </div>
                    <div className='col-lg-6 col-md-6'>
                        <div className='player2 mt-3'>
                            <h2 className=' player text-center'>Player-2</h2>
                            <h2 className=' '>Player Wallet Address</h2>
                        </div>

                    </div>
                </div>

                <div className='row mt-4 d-flex justify-content-center'>
                    <div className='col-6'>
                        <div className='player2 mt-3'>
                            <h2 className=' player text-center'>Result</h2>
                            <h2 className=' '>Winner is:-</h2>
                        </div>

                    </div>
                    </div>
            </div> */}



            <style jsx>
                {`
                body,#root,#root>div{
                    min-height: 100vh;
                    display:flex;
                    flex-direction:column;
                }
                body .row{
                    margin-top:auto
                }
                .checker-root canvas{
                    // height: 80vh !important;
                    // aspect-ratio:9/16 !important;
                    background: #000000;
                    height: 100vh;
                    width: 500px;
                    max-width: 100%;
                }
                #unity-build-title{
                    font-family: arial; 
                    font-size: 28px;
                    color: white;
                    display: flex;
                    justify-content: center;
                    margin-top: 12px;
                    margin-bottom: 12px;
                }
                @media (max-width: 768px) {
                    .checker-root canvas {height: 550px }
                    } 
                .player{
                    font-size: 20px;
                   
                }
                    .player2{
                    border: solid 1px red;
                    border-radius:10px;
                    // margin-top: 173px;
                    line-height:23px ;
                    padding: 15px 10px;
                    }
                
            `}
            </style>
        </>
    )
}

export default Checkers